import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const WhyChooseSection = () => {
  const { language } = useLanguage();
  const benefits = getTranslation(language, 'whyChooseSection.benefits');

  return (
    <section className="section-padding why-choose-section" id="why-choose">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0" data-aos="fade-right">
            <div className="why-choose-content">
              <h5 className="text-uppercase fw-bold" style={{ color: 'var(--secondary-color)', letterSpacing: '2px' }}>
                {getTranslation(language, 'whyChoose.title')}
              </h5>
              <h3>{getTranslation(language, 'whyChooseSection.subtitle')}</h3>
              <p className="mb-4">
                {getTranslation(language, 'whyChooseSection.description')}
              </p>
              <ul className="check-list">
                {Array.isArray(benefits) && benefits.map((benefit, index) => (
                  <li key={index}>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
              <a href="#contact" className="btn btn-demo mt-4">
                <i className="bi bi-arrow-right-circle me-2"></i>{getTranslation(language, 'whyChooseSection.getStarted')}
              </a>
            </div>
          </div>
          
          <div className="col-lg-6" data-aos="fade-left">
            <div className="why-choose-image text-center">
              <div className="position-relative">
                <div 
                  className="rounded-4 p-4"
                  style={{
                    background: 'var(--bg-gradient)',
                    boxShadow: 'var(--shadow-lg)'
                  }}
                >
                  <div className="row g-3">
                    <div className="col-6">
                      <div className="bg-white rounded-3 p-4 text-center">
                        <i className="bi bi-mortarboard-fill fs-1" style={{ color: 'var(--primary-color)' }}></i>
                        <h6 className="mt-2 mb-0">{getTranslation(language, 'whyChooseSection.preToPostGrad')}</h6>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="bg-white rounded-3 p-4 text-center">
                        <i className="bi bi-cloud-check-fill fs-1" style={{ color: 'var(--accent-color)' }}></i>
                        <h6 className="mt-2 mb-0">{getTranslation(language, 'whyChooseSection.cloudBased')}</h6>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="bg-white rounded-3 p-4 text-center">
                        <i className="bi bi-translate fs-1" style={{ color: 'var(--secondary-color)' }}></i>
                        <h6 className="mt-2 mb-0">{getTranslation(language, 'whyChooseSection.multiLanguage')}</h6>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="bg-white rounded-3 p-4 text-center">
                        <i className="bi bi-shield-check fs-1" style={{ color: 'var(--primary-color)' }}></i>
                        <h6 className="mt-2 mb-0">{getTranslation(language, 'whyChooseSection.govCompliant')}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
